<template>
  <section>
    <v-dialog v-model='repetidosModal' scrollable persistent max-width='1200'>
      <v-card>
        <v-toolbar dark color='primary'>
          <v-card-title><h4>{{tituloResumen}}</h4>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click='cancel()'>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form v-model='valid' ref='form' lazy-validation v-show='form1'>
            <v-layout wrap>
                <v-flex class="decretosBoton" sm12 md6>
                <div>
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span><br />Usted podrá buscar y obtener un resumen de la Declaración Jurada de Bienes y Rentas de cualquier Servidor Público.
                      <br />
                      <br />
                      <b>MARCO LEGAL</b>
                      <br />
                      <br />DECRETO SUPREMO 1233 ARTÍCULO 18.- (PUBLICACIÓN). I. Un resumen de la última Declaración Jurada de Bienes y Rentas, tomando en cuenta la fecha de su formulario, será publicada a través de la Página Web de la Declaración Jurada de Bienes y Rentas, conteniendo: Nombres y apellidos, fecha del formulario de la Declaración, Total de: Activos, Pasivos, Patrimonio y Rentas, y dejará de ser publicada cuando dicha fecha del formulario de declaración no sea la última o cuando su fecha de presentación tenga antigüedad <b> superior a dos (2) años.</b>
                  </span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
              </v-flex>
              <v-flex class="decretos" sm12 md6>
                <div class='texto-justicado'>
                  <br />Usted podrá buscar y obtener un resumen de la Declaración Jurada de Bienes y Rentas de cualquier Servidor Público.
                  <br />
                  <br />
                  <b>MARCO LEGAL</b>
                  <br />
                  <br />DECRETO SUPREMO 1233 ARTÍCULO 18.- (PUBLICACIÓN). I. Un resumen de la última Declaración Jurada de Bienes y Rentas, tomando en cuenta la fecha de su formulario, será publicada a través de la Página Web de la Declaración Jurada de Bienes y Rentas, conteniendo: Nombres y apellidos, fecha del formulario de la Declaración, Total de: Activos, Pasivos, Patrimonio y Rentas, y dejará de ser publicada cuando dicha fecha del formulario de declaración no sea la última o cuando su fecha de presentación tenga antigüedad <b> superior a dos (2) años.</b>
                </div>
              </v-flex>
              <v-flex sm12 md6>
                <br />
                <b>Formulario de Búsqueda</b>
                <div
                  class='texto-subtitulo texto-justicado'
                ><p>Digite los Apellidos y Nombres del servidor público del cual quiere ver el resumen, luego haga clic en 'Buscar'.</p></div>
                <v-text-field
                  label='Apellidos*'
                  required
                  :rules='dRules'
                  v-model='apellidos'
                  maxlength='80'
                  prepend-icon='edit'
                ></v-text-field>
                <v-text-field
                  label='Nombres*'
                  v-model='nombres'
                  prepend-icon='edit'
                  :rules='dRules'
                  required
                  maxlength='98'
                ></v-text-field>
                <br />
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader>
                      <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                    </v-subheader>
                  </v-flex>
                </v-layout>
                <p>Digite la letras y/o números que aparecen en la imagen</p>
                <v-layout row wrap>
                  <v-flex md3 offset-md1>
                    <img :src='imgb64' alt='Bolivia' />
                  </v-flex>
                  <v-flex md4 offset-md1>
                    <v-text-field
                      v-model='captcha'
                      :rules='this.useCaptcha ? dRules : []'
                      label='Respuesta'
                      :required="this.useCaptcha"
                      :maxlength="this.lengthCaptcha"
                    ></v-text-field>
                  </v-flex>
                  <v-flex md1>
                    <v-icon large @click='crearImagenCaptcha()'>cached</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout wrap>
            <v-flex sm12 md12>
              <v-alert
                :value='true'
                :type='statusError'
                v-show='codError !== null'
              >{{this.msgError}}</v-alert>
            </v-flex>
            <v-flex sm12 md12 v-if='this.nro>0'>
              <v-data-table
                :headers='headers'
                :items='datos'
                class='elevation-1'
                rows-per-page-text='Filas por página'
                :rows-per-page-items='rowsPerPageItems'
                v-show='table'
              >
                <template slot='no-data'>
                  <v-alert
                  class="tamanioBoton"
                    :value='true'
                    color='info'
                    icon='info'
                  >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
                </template>
                <template slot='items' slot-scope='props'>
                  <td>{{ props.item.nro }}</td>
                  <td class='justify-center layout px-0'>
                    <v-tooltip top color='blue'>
                      <template v-slot:activator='{ on }'>
                        <v-btn icon class='mx-0' @click='resumen(props.item)' v-on='on'>
                          <v-icon color='blue'>search</v-icon>
                        </v-btn>
                      </template>
                      <span>Resumen</span>
                    </v-tooltip>
                  </td>
                  <td>{{ props.item.perdec_nombres }}</td>
                  <td>{{ props.item.perdec_apellidos }}</td>
                  <td>{{ props.item.cardec_descripcion_entidad }}</td>
                  <td>{{ props.item.decjur_fecha_declaracion.substring(8, 10)}}/{{ props.item.decjur_fecha_declaracion.substring(5, 7)}}/{{ props.item.decjur_fecha_declaracion.substring(0, 4)}}</td>
                </template>
                <template
                  v-slot:pageText='props'
                >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
              </v-data-table>
            </v-flex>
            <v-flex sm12 md12 v-if='this.nro==0'>
              <v-alert
              class="tamanioBoton"
                :value='true'
                color='info'
                icon='info'
              >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
            </v-flex>
          </v-layout>
           <v-card-actions>
          <v-spacer></v-spacer>
          <div v-if='this.form1 === true'>
            <v-btn :loading="loadingButton" color='primary' @click="verificar(), loader = 'loadingButton'"><v-icon>search</v-icon>&nbsp;Buscar
               <template v-slot:loader>
                 <span>procesando..</span>
                </template>
            </v-btn>
          </div>
          <div v-if='this.form1 === false'>
            <v-btn class="tamanioBoton" color='primary' @click='nuevaBusqueda()'><v-icon>search</v-icon>&nbsp;Realizar Otra Búsqueda</v-btn>
          </div>
          <v-btn class="tamanioBoton" color='error' @click='cancel()'><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model='reporteModal' scrollable persistent max-width='850'>
      <v-card>
        <v-card-title>
          <center>
            <div class='imagen-logo'></div>
          </center>
          <h3 class='texto-titulo'>Extracto de la Declaración Jurada de Bienes y Rentas</h3>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click='dialog = false, limpiar2()'>
          <v-icon>close</v-icon>
        </v-btn>
        <v-card-text>
          <v-layout wrap>
            <v-flex sm12 md12>
              <h4 class='div-subtitulo'>Datos Generales del Declarante</h4>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm12 md12>
              <h4>{{ respuesta.nombres }} {{ respuesta.paterno }} {{ respuesta.materno }}</h4>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm12 md12>
              <h4 class='div-subtitulo'>Resumen de la Declaración Jurada de Bienes y Rentas</h4>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm6 md6>
              <b class='subtitulo'>Cantidad de Bienes (Cantidad total de 'BIENES'):</b>
            </v-flex>
            <v-flex sm6 md6>{{ respuesta.cantidadBienes }}</v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm6 md6>
              <b class='subtitulo'>Total 'BIENES' (Activos) :</b>
            </v-flex>
            <v-flex sm6 md6>{{ respuesta.totalBienes }}</v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm6 md6>
              <b class='subtitulo'>Total 'DEUDAS' (Pasivos) :</b>
            </v-flex>
            <v-flex sm6 md6>{{ respuesta.totalDeudas }}</v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm6 md6>
              <b class='subtitulo'>Total 'RENTAS' (Recibidas) :</b>
            </v-flex>
            <v-flex sm6 md6>{{ respuesta.totalRentas }}</v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm12 md12>
              <h4
                class='div-subtitulo'
              >Fecha de Presentación de la Declaración : {{ respuesta.fechaRecepcion }}</h4>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color='error' @click='reporteModal = false'><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="centered">
      <v-layout wrap>
        <v-flex md12>
          <v-btn color="transparent" fab large @click='iniciar ()'>
            <v-icon
              size="100"
              color="white"
            >
              search
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <br>
      <v-layout wrap>
        <v-flex md12>
          <p  class="padding-label" style="color:white;">
            <br><b> Búsqueda<br>de Resumen Público</b>
          </p>
        </v-flex>
      </v-layout>
    </div>
  </section>
</template>
<script>
import Captcha from './mixins/captcha.js';
import PdfView from '@/common/util/PdfView.vue';
export default {
  components: {
    PdfView
  },
  mixins: [Captcha],
  created () {
    this.crearImagenCaptcha();
  },
  data: () => ({
    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      { text: 'Nombre', sortable: false, value: 'perdec_nombres' },
      { text: 'Apellidos', sortable: false, value: 'perdec_apellidos' },
      { text: 'Entidad', sortable: false, value: 'cardec_descripcion_entidad' },
      {
        text: 'Fecha del Formulario',
        sortable: false,
        value: 'decjur_fecha_declaracion'
      }
    ],
    rowsPerPageItems: [5, 10, 25, { text: 'Todo', value: -1 }],
    datos: [],
    nro: null,
    repetidosModal: false,
    reporteModal: false,
    apellidos: '',
    nombres: '',
    valid: false,
    codError: null,
    msgError: null,
    statusError: null,
    codigo: null,
    control: null,
    form1: true,
    table: false,
    loadingButton: false,
    respuesta: {
      cantidadBienes: 0,
      totalBienes: 0,
      totalRentas: 0,
      totalDeudas: 0,
      paterno: '',
      materno: '',
      nombres: '',
      apCasada: '',
      fechaRecepcion: ''
    },
    captcha: '',
    imgb64: '',
    tokenCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA,
    dRules: [v => !!v || 'Este campo es requerido'],
    arrTextosResumen: ['Resumen Público', 'Resultado de la Búsqueda'],
    tituloResumen: ''
  }),
  methods: {
    async crearImagenCaptcha () {
      this.tituloResumen = this.arrTextosResumen[0];
      this.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    verificar () {
      if (this.$refs.form.validate()) {
        const params = {
          perdec_apellidos: this.apellidos,
          perdec_nombres: this.nombres,
          token: this.tokenCaptcha,
          captcha: this.captcha
        };
        this.loadingButton = true;
        this.$storage.set('token', process.env.TOKEN_EXTERNO);
        this.$service
          .post(`djbr_registro/consulta_publica`, params)
          .then(response => {
            this.$storage.remove('token');
            if (response) {
              this.form1 = false;
              this.table = true;
              this.loadingButton = false;
              this.nro = 0;
              if (response.length >= 1 && response[0].perdec_codigo !== -1) {
                this.datos = response;
                for (let i = 0; i < this.datos.length; i++) {
                  this.datos[i].nro = ++this.nro;
                }
                this.tituloResumen = this.arrTextosResumen[1];
              } else {
                this.datos = [];
                this.form1 = true;
                this.table = false;
                this.loadingButton = false;
              }
            } else {
              this.crearImagenCaptcha();
              this.form1 = true;
              this.table = false;
              this.loadingButton = false;
            }
          })
          .catch(error => {
            this.$storage.remove('token');
            console.error(error);
            this.form1 = true;
            this.table = false;
            this.loadingButton = false;
          });
      } else {
        this.$message['warning'](
          'Verificación Incorrecta, Datos requeridos incompletos.'
        );
      }
      this.$storage.remove('token');
    },
    resumen (item) {
      this.reinicializaResumen();
      this.codigo = item.perdec_codigo;
      this.control = item.decjur_control_cge;
      this.reporteModal = true;
      this.$storage.set('token', process.env.TOKEN_EXTERNO);
      this.$service
        .get(`djbr_registro/resumen_publico/${this.codigo}/${this.control}`, {})
        .then(response => {
          this.$storage.remove('token');
          if (response) {
            this.respuesta.cantidadBienes = response.resumen.cantidad_bienes;
            this.respuesta.totalBienes = response.resumen.total_valor_bienes;
            this.respuesta.totalRentas = response.resumen.total_valor_rentas;
            this.respuesta.totalDeudas = response.resumen.total_valor_deudas;
            this.respuesta.paterno = response.declarante.perdec_appaterno;
            this.respuesta.materno = response.declarante.perdec_apmaterno;
            this.respuesta.nombres = response.declarante.perdec_nombres;
            this.respuesta.apCasada = response.declarante.datcom_apcasada;
            this.respuesta.fechaRecepcion =
              response.declarante.decjur_fecha_recepcion;
          } else {
            this.$message['warning']('No es posible realizar la validación');
          }
        })
        .catch(error => {
          this.$storage.remove('token');
          console.error(error);
        });
      this.$storage.remove('token');
    },
    nuevaBusqueda () {
      this.form1 = true;
      this.table = false;
      this.apellidos = '';
      this.nombres = '';
      this.reinicializa();
      this.tituloResumen = this.arrTextosResumen[0];
    },
    limpiar2 () {
      this.reporteModal = false;
    },
    reinicializa () {
      this.nro = null;
      this.datos = [];
      this.respuesta.cantidadBienes = 0;
      this.respuesta.totalBienes = 0;
      this.respuesta.totalRentas = 0;
      this.respuesta.totalDeudas = 0;
      this.respuesta.paterno = '';
      this.respuesta.materno = '';
      this.respuesta.nombres = '';
      this.respuesta.apCasada = '';
      this.respuesta.fechaRecepcion = '';
      this.$refs.form.resetValidation();
      this.crearImagenCaptcha();
    },
    cancel () {
      this.repetidosModal = false;
      this.apellidos = '';
      this.nombres = '';
      this.reinicializa();
      this.form1 = true;
      this.table = false;
    },
    iniciar () {
      this.repetidosModal = true;
      this.crearImagenCaptcha();
    },
    reinicializaResumen () {
      this.respuesta.cantidadBienes = 0;
      this.respuesta.totalBienes = 0;
      this.respuesta.totalRentas = 0;
      this.respuesta.totalDeudas = 0;
      this.respuesta.paterno = '';
      this.respuesta.materno = '';
      this.respuesta.nombres = '';
      this.respuesta.apCasada = '';
      this.respuesta.fechaRecepcion = '';
    }
  }
};
</script>
<style>
.texto-justicado {
  text-align: justify;
  font-size: 14px;
}
.texto-subtitulo {
  font-size: 12px;
  color: #1565c0;
  text-align: center;
}
.div-subtitulo {
  background-color: #90caf9;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}
.imagen-logo {
  width: 300px !important;
  height: 80px !important;
  background-image: url(../../assets/images/logo_cge_pequenio.jpg);
  text-align: center;
  vertical-align: middle;
}
.texto-titulo {
  font-size: 16px;
  color: #1565c0;
  text-align: center;
  font-weight: bold;
}
.padding-label {
  padding-top: 5px;
  padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/portal/resumen.vue